<template>
  <v-row class="pa-6">
    <v-col cols="12">
      <v-card>
        <v-card-title>
          <div class="flex-grow-1">Laboratory Claims</div>
          <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table 
        :loading="loading" 
        :headers="headers" 
        :sort-by="'CLAIM_DATE'"
        :sort-desc="true" 
        :items="provider_data" 
        :search="search">
          <template v-slot:no-data>
            No Claims
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Laboratory',
  props: ['provider', 'insurance', 'startDate', 'endDate'],
  data() {
    return {
      search: '',
      loading: false,
      headers: [],
      provider_data: [],
    };
  },
  mounted() {
    this.getClaims();
  },
  methods: {
    async getHeaders() {
      const insurance = this.insurance.toLowerCase();

      if (insurance === 'careplus') {
        this.headers = [
          {
            text: 'Claim ID',
            sortable: false,
            value: 'LAB_CLAIM_ID',
          },
          { text: 'Claim Date', value: 'CLAIM_DATE' },
          { text: 'Facility', value: 'FACILITY' },
          { text: 'Diagnosis Code', value: 'PRIMARY_DIAG' },
          { text: 'Diagnosis Description', value: 'DIAG_DESC' },
          { text: 'Procedure Code', value: 'PROC_ID' },
          { text: 'Procedure Description', value: 'PROC_DESC' },
          { text: 'Amount', value: 'AMOUNT' },
        ];
      } else {
        this.headers = [
          {
            text: 'Claim ID',
            sortable: false,
            value: 'CLAIM_ID',
          },
          { text: 'Claim Date', value: 'CLAIM_DATE' },
          { text: 'Patient Name', value: 'MEMBER_NAME' },
          { text: 'Result Name', value: 'RESULT_NAME' },
          { text: 'Result Units', value: 'RESULT_UNITS' },
          { text: 'Result Value Literal', value: 'RESULT_VALUE_LITERAL' },
          { text: 'Normal High Value', value: 'NORMAL_HIGH_VALUE' },
          { text: 'Normal Low Value', value: 'NORMAL_LOW_VALUE' },
          { text: 'LOINC', value: 'LOINC' },
          { text: 'Physician Name/NPI', value: 'PHYSICIAN_NAME' },
        ];
      }
    },
    async getClaims() {
      this.provider_data = [];
      this.loading = true;
      this.getHeaders();

      const response = await axios
        .get(`api/provider/claims/laboratory/${this.insurance}/${this.provider}/${this.startDate}/${this.endDate}`)
        .then((response) => {
          this.provider_data = response.data;
          this.loading = false;
        });
    },
  },
  watch: {
    async startDate() {
      this.getClaims();
    },
    async endDate() {
      this.getClaims();
    },
  },
};
</script>
